import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroDealers } from './filtro-dealer';
import { IndicadorVendaVeiculoFiltroService } from './indicador-venda-veiculo-filtro.service';
import { IndicadorVendaVeiculoService } from './indicador-venda-veiculo.service';

declare var $: any;

@Component({
  selector: 'app-indicador-venda-veiculo',
  templateUrl: './indicador-venda-veiculo.component.html',
  styleUrls: ['./indicador-venda-veiculo.component.scss']
})
export class IndicadorVendaVeiculoComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  selecionado: object;
  selecionados = [];
  tipo = [];
  cols: any[];
  _selectedColumns: any[];
  dealersDados: any[] = [];
  numero_nfe: any;
  serie: any;
  id_dealer: any;
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  carregando: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  maxDate: Date = new Date();
  filtrosDealers: FiltroDealers;
  display: boolean = false;

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Dealer Number": "businessIntelligence.indicadorVendaVeiculo.dealerCod",
    "Dealer Name": "businessIntelligence.indicadorVendaVeiculo.dealerName",
    "Data": "businessIntelligence.indicadorVendaVeiculo.dataEmissao",
    "Chassi": "businessIntelligence.indicadorVendaVeiculo.chassi",
    "Modelo": "businessIntelligence.indicadorVendaVeiculo.modelo",
    "Tipo": "businessIntelligence.indicadorVendaVeiculo.tipo",
    "Cliente": "businessIntelligence.indicadorVendaVeiculo.cliente",
    "E-mail": "businessIntelligence.indicadorVendaVeiculo.email",
    "Cód. Cliente": "businessIntelligence.indicadorVendaVeiculo.codCliente",
    "DDD": "businessIntelligence.indicadorVendaVeiculo.ddd",  
    "Telefone": "businessIntelligence.indicadorVendaVeiculo.telefone"  
  }

  constructor(private service: IndicadorVendaVeiculoService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: IndicadorVendaVeiculoFiltroService,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder) {
    this.filtros = {};
    this.nomeModulo = 'indicador-venda-veiculo';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      tipo: [''],
      chassi: ['']
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.changeLanguageValue();
    this.preencherTipo();

    this.carregando = true;

    this.cols = [
      { field: 'codDealer', header: 'businessIntelligence.indicadorVendaVeiculo.dealerCod', headerBr: 'Dealer Number', headerGb: 'Dealer Number' },
      { field: 'nome', header: 'businessIntelligence.indicadorVendaVeiculo.dealerName', headerBr: 'Dealer Name', headerGb: 'Dealer Name' },
      { field: 'data', header: 'businessIntelligence.indicadorVendaVeiculo.dataEmissao', headerBr: 'Data', headerGb: 'Date' },
      { field: 'chassi', header: 'businessIntelligence.indicadorVendaVeiculo.chassi', headerBr: 'Chassi', headerGb: 'Chassi' },
      { field: 'modelo', header: 'businessIntelligence.indicadorVendaVeiculo.modelo', headerBr: 'Modelo', headerGb: 'Model' },
      { field: 'tipo', header: 'businessIntelligence.indicadorVendaVeiculo.tipo', headerBr: 'Tipo', headerGb: 'Type' },
      { field: 'nomeCliente', header: 'businessIntelligence.indicadorVendaVeiculo.cliente', Cliente: 'Valor', headerGb: 'Client' },
      { field: 'emailCliente', header: 'businessIntelligence.indicadorVendaVeiculo.email', headerBr: 'E-mail', headerGb: 'E-mail' },
      { field: 'codCliente', header: 'businessIntelligence.indicadorVendaVeiculo.codCliente', headerBr: 'Cód. Cliente', headerGb: 'Cód. Cliente' },
      { field: 'ddd', header: 'businessIntelligence.indicadorVendaVeiculo.ddd', headerBr: 'ddd', headerGb: 'ddd' },
      { field: 'telefone', header: 'businessIntelligence.indicadorVendaVeiculo.telefone', headerBr: 'Telefone', headerGb: 'Telephone' }
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private preencherTipo() {
    this.tipo = [
      { nome: 'Novo', valor: "N" },
      { nome: 'Usado', valor: "U" },  
    ];
  }

  private getAll() {
    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.tipo.value,
      this.f.chassi.value).subscribe(dados => {
        this.dealersDados = dados.dealers;
        this.orderByDate();

        this.dealersDados.forEach(element => {
          const atual = this.conversaoLibraConverte.conversaoLibra(element.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          element.valorVenda = valorFormatado.replace("R$", "");
          element.data = element.data.substring(0, 10);
        });

        this.carregando = false;
      });
  }

  private orderByDate() {
    this.dealersDados.sort((a, b) => {
      let data_a = a.data;
      let data_b = b.data;

      if (data_a > data_b) return -1;
      if (data_a < data_b) return 1;

      return 0;
    });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.carregando = true;
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.tipo.value
      || this.f.chassi.value      
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {    
    this.f.tipo.setValue('');
    this.f.chassi.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "businessIntelligence.indicadorVendaVeiculo.dealerCod") {
      return "Cód. Dealer";
    }
    if (item == "businessIntelligence.indicadorVendaVeiculo.dealerName") {
      return "Dealer";
    }
    if (item == "businessIntelligence.indicadorVendaVeiculo.dataEmissao") {
      return "Data";
    }
    if (item == "businessIntelligence.indicadorVendaVeiculo.chassi") {
      return "Chassi";
    }
    if (item == "businessIntelligence.indicadorVendaVeiculo.modelo") {
      return this.translate.currentLang == "br" ? "Modelo" : "Model";
    }
    if (item == "businessIntelligence.indicadorVendaVeiculo.tipo") {
      return this.translate.currentLang == "br" ? "Tipo" : "Type";
    }    
    if (item == "businessIntelligence.indicadorVendaVeiculo.cliente") {
      return this.translate.currentLang == "br" ? "Cliente" : "Client";
    }    
    if (item == "businessIntelligence.indicadorVendaVeiculo.email") {
      return "E-mail";
    }    
    if (item == "businessIntelligence.indicadorVendaVeiculo.codCliente") {
      return this.translate.currentLang == "br" ? "Cód. Cliente" : "Cod. Client";
    }    
    if (item == "businessIntelligence.indicadorVendaVeiculo.ddd") {
      return "DDD";
    }    
    if (item == "businessIntelligence.indicadorVendaVeiculo.telefone") {
      return this.translate.currentLang == "br" ? "Telefone" : "Telephone";
    }    
  }

  private translateField(item) {
    return item;
  }

  public exportExcel() {
    let registros = [];

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.chassi.value, this.f.tipo.value).subscribe(dados => {
        registros = dados.dealers;
        this.orderByDate();

        registros.forEach(dados => {
          const atual = this.conversaoLibraConverte.conversaoLibra(dados.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);          
          dados.data = dados.data.substring(0, 10);
        });

        if (registros.length > 0) {
          this.exportExcelService.nomeModulo = this.nomeModulo;
          this.exportExcelService.formatType = "0.00";
          this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
            let linha = {};

            this._selectedColumns.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
      });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.carregando = true;
        this.getAll();
      });
  }

}
